import LocalTime from 'local-time'

import '@hotwired/turbo-rails'
import './controllers'
import '@37signals/lexxy'

LocalTime.start()
